import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'getLabel'
})
export class FieldPipe implements PipeTransform {

  transform(id: string, items:any ): string {

    let i = items.find(v => v.Id == id);

    if(!i){
      return "This content seems to have been deleted";
    }

    return items.find(v => v.Id == id).Label; // Check if any "eating" property is equal to food
  }

}
